import React, { useEffect, useRef, useState } from "react";
import { TextField, InputLabel, MenuItem } from "@mui/material";
import { TbPhotoPlus } from "react-icons/tb";
import { FaAngleLeft } from "react-icons/fa";
import { Button, message, Radio, Checkbox, Modal } from "antd";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  post_product,
  productImagePost,
  updateImages,
  validateSlugUrl,
} from "../../../redux/Product/ProductSlice";
import { FaPlus } from "react-icons/fa6";
import { add_add_ons } from "../../../redux/add_ons/AddOnsSlice";

const AddProducts = () => {
  const dispatch = useDispatch();
  const { sub_category_all } = useSelector((store) => store.subcategory);
  const { category_all } = useSelector((store) => store.category);
  const { restaurant_all } = useSelector((store) => store.restaurant);
  const { thumbnail, current_category, current_menu } = useSelector(
    (store) => store.product
  );
  const { add_ons_all } = useSelector((store) => store.addons);

  const [categoryName, setCategoryName] = useState("");
  const [subcategoryName, setsubCategoryName] = useState("");
  const [menuName, setmenuName] = useState("");

  const [resto_info, setresto_info] = useState("");

  const [productName, setproductName] = useState("");
  const [productUrl, setproductUrl] = useState("");
  const [productError, setproductError] = useState("");
  const [button_press, setButton_press] = useState(false);

  const [Product_type, setProduct_type] = useState("nonveg");
  const [product_discription, setproduct_discription] = useState("");

  const [cat_subcat, setcat_subcat] = useState([]);
  const [selectedcatMenu, SetSelectedcatMenu] = useState([]);

  const [cnfopen, setCnfOpen] = useState(false);
  const [addonName, setaddonName] = useState("");
  const [addonNameCnf, setaddonNameCnf] = useState("");
  const [addonNameButtonPress, setaddonNameButtonPress] = useState("");

  const [all_addons, setall_addons] = useState([]);
  const [selectedall_addons, setselectedall_addons] = useState([]);

  const [packsize, Setpacksize] = useState([
    {
      packSizeName: "",
      Price: "",
      Prime: true,
    },
  ]);

  const [messageApi, contextHolder] = message.useMessage();
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (add_ons_all.length > 0) {
      let data = [];
      for (let index = 0; index < add_ons_all.length; index++) {
        let element = add_ons_all[index].name;
        data = [...data, element];
      }
      setall_addons(data);
    }
  }, [add_ons_all]);

  useEffect(() => {
    if (current_category) {
      setCategoryName(current_category);
    }
    if (current_menu) {
      setmenuName(current_menu);
    }
  }, [current_category, current_menu]);

  useEffect(() => {
    if (categoryName) {
      const filter_subcat = sub_category_all.filter(
        (data) => data.category === categoryName
      );
      setcat_subcat(filter_subcat);
    }
  }, [categoryName, sub_category_all]);

  useEffect(() => {
    if (restaurant_all.length > 0) {
      const find_resto = restaurant_all.find(
        (data) => data.mobile === Number(8328059954)
      );
      if (find_resto) {
        setresto_info(find_resto);
        const menu = find_resto.menu;
        if (categoryName) {
          const cat_menu = menu.filter(
            (data) => data.category === categoryName
          );
          SetSelectedcatMenu(cat_menu);
        }
      }
    }
  }, [restaurant_all, categoryName]);

  const handleCatSelectPress = (evt) => {
    if (selectedall_addons.includes(evt)) {
      setselectedall_addons(
        selectedall_addons.filter((e) => {
          return e !== evt;
        })
      );
    } else {
      setselectedall_addons((selectedall_addons) => [
        ...selectedall_addons,
        evt,
      ]);
    }
  };

  const handleCnfOk = async () => {
    setaddonNameButtonPress(true);
    if (addonName !== "") {
      setaddonNameCnf(addonName);
      setall_addons([...all_addons, addonName]);
      setaddonNameButtonPress(false);
      setCnfOpen(false);
    }
  };

  const check_product_url = async (e) => {
    const value = e.target.value;
    setproductName(value);
    setproductError("");
    if (value) {
      const url = value
        .trim()
        .toLowerCase()
        .replace(" ", "-")
        .replace(/[.*+&?^ $@#%^!'{}()|[\]\\]/g, "-")
        .replace("--", "-")
        .replace("---", "-")
        .replace("----", "-")
        .replace("/", "-")
        .replace("//", "-")
        .replace("///", "-");

      const verify = await dispatch(validateSlugUrl(url));
      if (verify.payload.success === false) {
        setproductUrl(url);
        setproductError("");
      } else {
        setproductUrl("");
        setproductError(verify.payload.message);
      }
    }
  };

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const check_pack_option = (value, field_name, index) => {
    let pack = [...packsize];
    pack[index][field_name] = value;
    Setpacksize([...pack]);
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const files = Array.from(e.target.files);
      files.forEach((file) => {
        const reader = new FileReader();
        reader.onload = async () => {
          if (reader.readyState === 2) {
            const get_img = await dispatch(
              productImagePost({ logo: reader.result })
            );
          }
        };
        reader.readAsDataURL(file);
      });
    }
  };

  useEffect(() => {
    if (button_press === true) {
      if (productUrl === "") {
        setproductError("Enter product name");
      }
    }
  }, [button_press, productUrl]);

  const submitPress = async () => {
    setButton_press(true);

    if (productUrl === "") {
      setproductError("Enter product name");
    }

    const last_edit_pack = packsize.find((data) => data.Prime === true);

    if (
      categoryName !== "" &&
      thumbnail !== "" &&
      //   subcategoryName !== "" &&
      product_discription !== "" &&
      resto_info !== "" &&
      menuName !== "" &&
      last_edit_pack.packSizeName !== "" &&
      last_edit_pack.Price !== "" &&
      Product_type !== ""
    ) {
      const cat_find = category_all.find((data) => data.name === categoryName);
      const subcat = sub_category_all.find(
        (data) => data.name === subcategoryName
      );

      let vegstatus = false;
      let nonStatus = false;

      if (Product_type === "nonveg") {
        nonStatus = true;
      } else {
        vegstatus = true;
      }

      const formdata = {
        name: productName,
        slugUrl: productUrl,
        thumbnail: thumbnail,
        description: product_discription,
        restauntId: resto_info._id,
        restaunt: resto_info.name,
        category: cat_find.name,
        categoryUrl: cat_find.slugUrl,
        // subcategory: subcat.name,
        // subcategoryUrl: subcat.slugUrl,
        veg: vegstatus,
        Nonveg: nonStatus,
        menu_type: menuName,
        packSize: packsize,
      };

      const form_posting = await dispatch(post_product(formdata));
      if (form_posting.payload.success === true) {
        const product = form_posting.payload.product;
        if (selectedall_addons.length > 0) {
          let formArray = [];

          for (let index = 0; index < selectedall_addons.length; index++) {
            let element = selectedall_addons[index];
            const formdata = {
              name: element,
              restauntId: "6703ad1f8645725a27441b26",
              productId: product._id,
              packSizeName: packsize[0].packSizeName,
              Price: packsize[0].Price,
              status: true,
            };
            formArray = [...formArray, formdata];
          }
          const formdata = {
            addons: formArray,
          };
          await dispatch(add_add_ons(formdata));
        }
        messageApi.open({
          type: "success",
          content: `Product add Successfully`,
        });
        const formdata = {
          thumbnail: "",
        };
        dispatch(updateImages(formdata));
        // setCategoryName("");
        setsubCategoryName("");
        // setmenuName("");
        setresto_info("");
        setproductName("");
        setproductUrl("");
        setproductError("");
        setProduct_type("nonveg");
        setproduct_discription("");
        setcat_subcat([]);
        SetSelectedcatMenu([]);
        setselectedall_addons([]);
        Setpacksize([
          {
            packSizeName: "",
            Price: "",
            Prime: true,
          },
        ]);
        setButton_press(false);
      }
    }
  };

  const input_lable_style = {
    color: "#1a1a1a",
    fontSize: "0.75rem",
    fontWeight: "800",
    marginBottom: "0.5vh",
    textTransform: "uppercase",
  };

  return (
    <>
      {contextHolder}

      <Modal
        open={cnfopen}
        title=""
        onOk={handleCnfOk}
        onCancel={() => setCnfOpen(false)}
        maskClosable={false}
        closable={false}
        style={{
          top: 20,
        }}
        footer={[
          <Button className="confirm_btn btn_apt" onClick={handleCnfOk}>
            ADD
          </Button>,
        ]}
      >
        <div className="add_mod_container">
          <div className="input_box_container">
            <InputLabel sx={input_lable_style} htmlFor="custom-input">
              Addons Name <sup className="star_colour">*</sup>
            </InputLabel>
            <TextField
              id="custom-input"
              placeholder="Enter Name"
              variant="outlined"
              error={
                addonName === "" && addonNameButtonPress === true ? true : false
              }
              helperText={
                addonName === "" && addonNameButtonPress === true
                  ? "Enter Name"
                  : ""
              }
              InputProps={{
                style:
                  addonName === "" && addonNameButtonPress === true
                    ? {
                        backgroundColor: "#ffe6e6",
                        border: "1px solid red",
                      }
                    : {},
              }}
              autocomplete="off"
              size="small"
              className="input_container"
              onChange={(e) => setaddonName(e.target.value)}
              value={addonName}
              FormHelperTextProps={{
                style: {
                  marginTop: "0vh",
                },
              }}
            />
          </div>
        </div>
      </Modal>

      <div className="add_page_main">
        <div className="add_hedaer_main_cnf">
          <div className="add_page_header">
            <h4>Add New Product</h4>
            <Link to="/admin/product-list">
              <div className="bac_add_nav">
                <span>
                  <FaAngleLeft color="#333333" />
                </span>
                <h6>Product List</h6>
              </div>
            </Link>
          </div>
        </div>
        <div className="add_input_box_main">
          <div className="add_page">
            <div className="input_container">
              <div className="input_box_container">
                <InputLabel sx={input_lable_style} htmlFor="custom-input">
                  Select Category <sup className="star_colour">*</sup>
                </InputLabel>
                <TextField
                  id="custom-select"
                  select
                  variant="outlined"
                  size="small"
                  className="input_container"
                  error={
                    categoryName === "" && button_press === true ? true : false
                  }
                  helperText={
                    categoryName === "" && button_press === true
                      ? "Select category"
                      : ""
                  }
                  InputProps={{
                    style:
                      categoryName === "" && button_press === true
                        ? {
                            backgroundColor: "#ffe6e6",
                            border: "1px solid red",
                          }
                        : {},
                  }}
                  value={categoryName}
                  onChange={(e) => setCategoryName(e.target.value)}
                  displayEmpty
                  // renderValue={
                  //   categoryName !== "" ? undefined : () => "Select Category"
                  // }
                >
                  {category_all.map((data, index) => (
                    <MenuItem key={index} value={data.name}>
                      {data.name}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
              {/* <div className="input_box_container">
                <InputLabel sx={input_lable_style} htmlFor="custom-input">
                  Select Sub-Category <sup className="star_colour">*</sup>
                </InputLabel>
                <TextField
                  id="custom-select"
                  select
                  variant="outlined"
                  size="small"
                  className="input_container"
                  defaultValue=""
                  error={
                    subcategoryName === "" && button_press === true
                      ? true
                      : false
                  }
                  helperText={
                    subcategoryName === "" && button_press === true
                      ? "Select Sub-category"
                      : ""
                  }
                  InputProps={{
                    style:
                      subcategoryName === "" && button_press === true
                        ? {
                            backgroundColor: "#ffe6e6",
                            border: "1px solid red",
                          }
                        : {},
                  }}
                  value={subcategoryName}
                  onChange={(e) => setsubCategoryName(e.target.value)}
                  displayEmpty
                  // renderValue={
                  //   subcategoryName !== "" ? undefined : () => "Select Sub-Category"
                  // }
                >
                  {cat_subcat.map((data, index) => (
                    <MenuItem key={index} value={data.name}>
                      {data.name}
                    </MenuItem>
                  ))}
                </TextField>
              </div> */}
              <div className="input_box_container">
                <InputLabel sx={input_lable_style} htmlFor="custom-input">
                  Name
                </InputLabel>
                <TextField
                  id="custom-input"
                  placeholder="Enter Name"
                  variant="outlined"
                  error={productError !== "" ? true : false}
                  helperText={productError}
                  autocomplete="off"
                  size="small"
                  className="input_container"
                  onChange={(e) => check_product_url(e)}
                  value={productName}
                  InputProps={{
                    style:
                      productError !== ""
                        ? {
                            backgroundColor: "#ffe6e6",
                            border: "1px solid red",
                          }
                        : {},
                  }}
                  FormHelperTextProps={{
                    style: {
                      marginTop: "0vh",
                    },
                  }}
                />
              </div>
              <div className="input_box_container">
                <InputLabel sx={input_lable_style} htmlFor="custom-input">
                  Select Menu <sup className="star_colour">*</sup>
                </InputLabel>
                <TextField
                  id="custom-select"
                  select
                  variant="outlined"
                  size="small"
                  className="input_container"
                  defaultValue=""
                  error={
                    menuName === "" && button_press === true ? true : false
                  }
                  helperText={
                    menuName === "" && button_press === true
                      ? "Select Menu Type"
                      : ""
                  }
                  InputProps={{
                    style:
                      menuName === "" && button_press === true
                        ? {
                            backgroundColor: "#ffe6e6",
                            border: "1px solid red",
                          }
                        : {},
                  }}
                  value={menuName}
                  onChange={(e) => setmenuName(e.target.value)}
                  displayEmpty
                  // renderValue={
                  //   subcategoryName !== "" ? undefined : () => "Select Sub-Category"
                  // }
                >
                  {selectedcatMenu.map((data, index) => (
                    <MenuItem key={index} value={data.name}>
                      {data.name}
                    </MenuItem>
                  ))}
                </TextField>
              </div>
              <div className="input_box_container">
                <InputLabel sx={input_lable_style} htmlFor="custom-input">
                  Image
                </InputLabel>
                {!thumbnail ? (
                  <>
                    <div
                      className={
                        thumbnail === "" && button_press === true
                          ? "imageref_box image_error_input"
                          : "imageref_box"
                      }
                      onClick={handleImageClick}
                    >
                      <TbPhotoPlus size={28} color="#999999" />
                    </div>
                  </>
                ) : (
                  <>
                    <div className="imageref_box" onClick={handleImageClick}>
                      <img src={thumbnail} alt="img" />
                    </div>
                  </>
                )}

                <span className="sub_text_title">Aspect Ratio - 4:3</span>
                <input
                  type="file"
                  ref={fileInputRef}
                  style={{ display: "none" }}
                  onChange={handleFileChange}
                />
              </div>
              <div className="input_box_container">
                <InputLabel sx={input_lable_style} htmlFor="custom-input">
                  Product Type
                </InputLabel>

                <Radio.Group
                  onChange={(e) => setProduct_type(e.target.value)}
                  value={Product_type}
                >
                  <Radio value="veg">Veg</Radio>
                  <Radio value="nonveg">Non Veg</Radio>
                </Radio.Group>
              </div>
              <div className="input_box_container">
                <InputLabel sx={input_lable_style} htmlFor="custom-input">
                  Product Discription <sup className="star_colour">*</sup>
                </InputLabel>
                <TextField
                  id="custom-multiline-input"
                  multiline
                  rows={4}
                  placeholder="Enter Product Discription"
                  variant="outlined"
                  autocomplete="off"
                  size="small"
                  className="input_container"
                  error={
                    button_press === true && product_discription === ""
                      ? true
                      : false
                  }
                  helperText={
                    button_press === true && product_discription === ""
                      ? "Enter Product Discription"
                      : ""
                  }
                  onChange={(e) => setproduct_discription(e.target.value)}
                  value={product_discription}
                  InputProps={{
                    style:
                      button_press === true && product_discription === ""
                        ? {
                            backgroundColor: "#ffe6e6",
                            border: "1px solid red",
                          }
                        : {},
                  }}
                  FormHelperTextProps={{
                    style: {
                      marginTop: "0vh",
                    },
                  }}
                />
              </div>
              <div className="input_box_container cate_list_box_res">
                <div className="menu_main_box_header">
                  <div className="mn_hd_box">
                    <div className="mn_hd_titl">
                      <h5>AddOns</h5>
                    </div>
                    <div
                      className="mn_hd_icon_box"
                      style={{
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setCnfOpen(true);
                        setaddonName("");
                      }}
                    >
                      <FaPlus className="menu_hd_icon" />
                    </div>
                  </div>
                </div>
                <div className="menu_list_box">
                  <ul>
                    {all_addons &&
                      all_addons.map((data, index) => (
                        <li key={index}>
                          <span className="item_name">{data}</span>
                          <span className="item_ed_icon">
                            <Checkbox
                              className="custom-checkbox"
                              value={data}
                              checked={selectedall_addons.includes(data)}
                              onChange={() => handleCatSelectPress(data)}
                            />
                          </span>
                        </li>
                      ))}
                  </ul>
                </div>
              </div>
              {packsize.map((pack, index) => (
                <div className="packsize_container" key={index}>
                  <div className="pacsize_input_box">
                    <InputLabel sx={input_lable_style} htmlFor="custom-input">
                      Option Name
                    </InputLabel>
                    <TextField
                      id="custom-input"
                      placeholder="Enter Pack Option"
                      variant="outlined"
                      error={
                        pack?.packSizeName === "" &&
                        button_press === true &&
                        pack?.Prime === true
                          ? true
                          : false
                      }
                      helperText={
                        pack?.packSizeName === "" &&
                        button_press === true &&
                        pack?.Prime === true
                          ? "Pnter Pack Option"
                          : ""
                      }
                      autocomplete="off"
                      size="small"
                      className="input_container"
                      onChange={(e) =>
                        check_pack_option(e.target.value, "packSizeName", index)
                      }
                      value={pack?.packSizeName}
                      InputProps={{
                        style:
                          pack?.packSizeName === "" &&
                          button_press === true &&
                          pack?.Prime === true
                            ? {
                                backgroundColor: "#ffe6e6",
                                border: "1px solid red",
                              }
                            : {},
                      }}
                      FormHelperTextProps={{
                        style: {
                          marginTop: "0vh",
                        },
                      }}
                    />
                  </div>
                  <div className="pacsize_input_box">
                    <InputLabel sx={input_lable_style} htmlFor="custom-input">
                      Option Price
                    </InputLabel>
                    <TextField
                      id="custom-input"
                      placeholder="Enter Pack Price"
                      variant="outlined"
                      error={
                        pack?.Price === "" &&
                        button_press === true &&
                        pack?.Prime === true
                          ? true
                          : false
                      }
                      helperText={
                        pack?.Price === "" &&
                        button_press === true &&
                        pack?.Prime === true
                          ? "Pnter Pack Price"
                          : ""
                      }
                      autocomplete="off"
                      size="small"
                      className="input_container"
                      onChange={(e) =>
                        check_pack_option(e.target.value, "Price", index)
                      }
                      value={pack?.Price}
                      InputProps={{
                        style:
                          pack?.Price === "" &&
                          button_press === true &&
                          pack?.Prime === true
                            ? {
                                backgroundColor: "#ffe6e6",
                                border: "1px solid red",
                              }
                            : {},
                      }}
                      FormHelperTextProps={{
                        style: {
                          marginTop: "0vh",
                        },
                      }}
                    />
                  </div>
                </div>
              ))}

              <div className="submit_btn_container">
                <Button
                  className="confirm_btn sub_padding"
                  onClick={() => submitPress()}
                >
                  Submit
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddProducts;
